import { render, staticRenderFns } from "./BasePage.vue?vue&type=template&id=18c794ec&scoped=true"
import script from "./BasePage.vue?vue&type=script&lang=js"
export * from "./BasePage.vue?vue&type=script&lang=js"
import style0 from "./BasePage.vue?vue&type=style&index=0&id=18c794ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c794ec",
  null
  
)

export default component.exports